export default "__VITE_ASSET__CcBGQ14n__"